import { loadCookie } from 'lib/cookies';
import { xsrfCookieName } from 'lib/http';

export const AuthenticityToken = () => {
  return (
    <input
      type="hidden"
      name="authenticity_token"
      value={loadCookie(xsrfCookieName)}
    />
  );
};
